import React from 'react';

const Button = ({
  as: Component = 'button',
  className = '',
  variant = 'primary',
  children,
  ...props
}) => {
  const classes = ['c-button', `c-button--${variant}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
};

export default Button;
